if (!customElements.get('taylors-footer')) {
  class TaylorsFooter extends HTMLElement {
    constructor() {
      super();
      this.handleChange = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.columns = Array.from(this.querySelectorAll('.tf-column'));
      this.mq = window.matchMedia('(min-width: 750px)');
      this.mq.addEventListener('change', this.handleChange);
      this.handleChange();
    }

    disconnectedCallback() {
      this.mq?.removeEventListener('change', this.handleChange);
    }

    handleChange() {
      const isDesktop = this.mq.matches;
      this.columns.forEach((col) => {
        if (isDesktop) {
          col.setAttribute('open', '');
        } else {
          col.removeAttribute('open');
        }
      });
    }
  }

  customElements.define('taylors-footer', TaylorsFooter);
}
